/* eslint-disable react-hooks/exhaustive-deps */

import {useMutation, useQuery} from "@apollo/react-hooks";
import {makeStyles} from '@material-ui/core/styles';
import React, {useCallback, useEffect, useState} from 'react';
import {
    CREATE_PHONE_NUMBER,
    DELETE_PHONE_NUMBER,
    GET_PHONE_NUMBERS_OF_PARENT,
    UPDATE_PHONE_NUMBER
} from "../../database/queries/phoneNumberQueries";
import MaterialTable, {MTableEditField} from "material-table";
import tableIcons from "../../constants/tableIcons";
import {SizeMe} from "react-sizeme";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import ChooseFromChoices from "../Common/chooseFromChoices";
import {PHONE_NUMBER_TYPE_CHOICES} from "../../database/queries/enumQueries";
import PhoneInput from "react-phone-number-input";
import usePersistentStore from "../../persistentStore";
import {simulateMouseClick} from "../../utils/utils";
import {CREATE_WEB_HISTORY} from "../../database/queries/webHistoryQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    table: {
        '& .MuiTypography-root': {
            fontSize: '1rem',
        }
    }
}));

// function validatePhoneNumber(phoneNumber) {
//     var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
//     return re.test(phoneNumber);
// }

const PopupPhoneNumbers = props => {
    const classes = useStyles();
    const [globalLayoutState] = useLayoutStore();
    const [globalPersistentState] = usePersistentStore();
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState();
    const [phoneNumberType, setPhoneNumberType] = useState('office');

    const {loading: getPhoneNumbersOfParentLoading, error: getPhoneNumbersOfParentError, data: getPhoneNumbersOfParentData, refetch: getPhoneNumbersOfParentRefetch} = useQuery(GET_PHONE_NUMBERS_OF_PARENT, {
        skip: !props.editId || props.editId === 'new',
        variables: {
            parentType: props.editType,
            parentId: props.editId,
            orderList: ['phoneNumber ASC']
        },
    });

    const [createPhoneNumber, {error: createPhoneNumberError}] = useMutation(CREATE_PHONE_NUMBER);
    const [updatePhoneNumber, {error: updatePhoneNumberError}] = useMutation(UPDATE_PHONE_NUMBER);
    const [deletePhoneNumber, {error: deletePhoneNumberError}] = useMutation(DELETE_PHONE_NUMBER);
    const [createWebHistory] = useMutation(CREATE_WEB_HISTORY);

    const columns = [
        {title: 'PhoneNumber', field: 'phoneNumber', width: '50%'},
        {title: 'Type', field: 'phoneNumberType', width: '25%'},
        {title: 'Primary', field: 'primary', type: 'boolean', width: '25%'},
    ];

    const components = {
        EditField: efprops => {
            if (efprops.columnDef.field === 'phoneNumber') {
                let value = phoneNumber;
                if (!value && efprops.value) value = efprops.value;
                if (!value || !value.startsWith('+')) value = '+' + value;
                return (
                    <PhoneInput
                        placeholder="Enter phoneRec #"
                        autoFocus
                        value={value}
                        style={{fontSize: 16}}
                        className={classes.phoneInput}
                        onChange={(newPhoneNumber) => {
                            setPhoneNumber(newPhoneNumber);
                            return newPhoneNumber;
                        }}
                    />
                )
            } else if (efprops.columnDef.field === 'phoneNumberType') {
                let value = efprops.value;
                if (!value && phoneNumberType) value = phoneNumberType;
                return (
                    <ChooseFromChoices
                        choicesQuery={PHONE_NUMBER_TYPE_CHOICES}
                        required={true}
                        value={value}
                        onChange={(newPhoneNumberType) => {
                            setPhoneNumberType(newPhoneNumberType);
                            return newPhoneNumberType;
                        }}
                    />
                )
            } else {
                return (<MTableEditField {...efprops} />);
            }
        },
    };

    const fixPhone = (p) => {
        let fixedPhone = p.replace(/[^0-9]/g, '').replace(/^1/, '');
        if (fixedPhone.length <= 10) fixedPhone = '1' + fixedPhone;
        return fixedPhone
    }

    useEffect(() => {
        if (createPhoneNumberError) notify('createPhoneNumberError', 'error', createPhoneNumberError.message, null, null, globalPersistentState.popupQueryObj);
        if (deletePhoneNumberError) notify('deletePhoneNumberError', 'error', deletePhoneNumberError.message, null, null, globalPersistentState.popupQueryObj);
        if (getPhoneNumbersOfParentError) notify('getPhoneNumbersOfParentError', 'error', getPhoneNumbersOfParentError.message, null, null, globalPersistentState.popupQueryObj);
        if (updatePhoneNumberError) notify('updatePhoneNumberError', 'error', updatePhoneNumberError.message, null, null, globalPersistentState.popupQueryObj);
    }, [createPhoneNumberError, deletePhoneNumberError, getPhoneNumbersOfParentError, updatePhoneNumberError]);

    useEffect(() => {
        getPhoneNumbersOfParentRefetch();
    }, [getPhoneNumbersOfParentRefetch]);

    useEffect(() => {
    }, [globalLayoutState.editTabBarHeight]);

    const tableCallback = useCallback(node => {
        const addBtn = document.querySelector('button[title="Add"]')
        if (addBtn && globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionText) {
            const fixedPhone = fixPhone(globalPersistentState.popupQueryObj.selectionText);

            if (fixedPhone.length > 0) {
                const foundNumbers = phoneNumbers.filter(pObj => pObj.phoneNumber === fixedPhone);

                if (foundNumbers.length === 0) {
                    setPhoneNumber(fixedPhone);
                    simulateMouseClick(addBtn);
                }
            }
        }
    }, []);

    useEffect(() => {
        if (getPhoneNumbersOfParentData && getPhoneNumbersOfParentData.phoneNumbersOfParent) {
            let fetchedPhones = [];
            for (let p = 0; p < getPhoneNumbersOfParentData.phoneNumbersOfParent.length; p++) {
                const phoneRec = getPhoneNumbersOfParentData.phoneNumbersOfParent[p];
                fetchedPhones.push({...phoneRec, phoneNumber: '+' + phoneRec.phoneNumber})
            }
            setPhoneNumbers(fetchedPhones)
        }
    }, [getPhoneNumbersOfParentData]);

    if (getPhoneNumbersOfParentLoading) return <p>Loading ...</p>;
    if (getPhoneNumbersOfParentError) return `Error! ${getPhoneNumbersOfParentError.message}`;

    return (
        <div className={classes.root}>
            {phoneNumbers && (
                <div>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;
                            const fudge = 10;

                            const tableOptions = {
                                maxBodyHeight: height - (globalLayoutState.editTabBarHeight + fudge),
                                padding: 'dense',
                                addRowPosition: 'first',
                                header: true,
                                paging: false,
                                showTitle: true,
                                search: false,
                                actionsColumnIndex: -1
                            };

                            return (
                                <div ref={tableCallback}>
                                    <MaterialTable
                                        icons={tableIcons}
                                        title={`Phone Numbers ${props.editObj ? 'of ' + props.editObj.displayName : ''}`}
                                        columns={columns}
                                        data={phoneNumbers}
                                        options={tableOptions}
                                        components={components}
                                        editable={{
                                            onRowAdd: newData =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        let variables = {
                                                            newPhoneNumber: {
                                                                parentType: props.editType,
                                                                parentId: props.editId,
                                                                phoneNumber: fixPhone(phoneNumber),
                                                                phoneNumberType: phoneNumberType,
                                                                primary: (newData.primary === true),
                                                            }
                                                        };
                                                        createPhoneNumber({
                                                            variables: variables
                                                        }).then(async createResult => {
                                                            if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                                await createWebHistory({
                                                                    variables: {
                                                                        newWebHistory: {
                                                                            parentType: 'phoneNumber',
                                                                            parentId: createResult.data.createPhoneNumber.id,
                                                                            url: globalPersistentState.popupQueryObj.selectionUrl
                                                                        }
                                                                    }
                                                                })
                                                            }
                                                            setPhoneNumber();
                                                            getPhoneNumbersOfParentRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            reject();
                                                        });
                                                        resolve()
                                                    }, 1000)
                                                }),
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        let variables = {
                                                            changedPhoneNumber: {
                                                                phoneNumberId: oldData.phoneNumberId,
                                                                phoneNumber: fixPhone(phoneNumber ? phoneNumber : oldData.phoneNumber),
                                                                phoneNumberType: phoneNumberType ? phoneNumberType : oldData.phoneNumberType,
                                                                primary: (newData.primary === true),
                                                            }
                                                        };
                                                        updatePhoneNumber({
                                                            variables: variables
                                                        }).then(async updateResult => {
                                                            if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                                await createWebHistory({
                                                                    variables: {
                                                                        newWebHistory: {
                                                                            parentType: 'phoneNumber',
                                                                            parentId: oldData.phoneNumberId,
                                                                            url: globalPersistentState.popupQueryObj.selectionUrl
                                                                        }
                                                                    }
                                                                })
                                                            }
                                                            setPhoneNumber();
                                                            getPhoneNumbersOfParentRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            reject();
                                                        });
                                                        resolve()
                                                    }, 1000)
                                                }),
                                            onRowDelete: oldData =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        deletePhoneNumber({
                                                            variables: {
                                                                deletePhoneNumberId: oldData.phoneNumberId,
                                                            }
                                                        }).then(() => {
                                                            getPhoneNumbersOfParentRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            reject();
                                                        });
                                                        resolve()
                                                    }, 1000)
                                                }),
                                        }}
                                    />
                                </div>
                            );
                        }}
                    </SizeMe>
                </div>
            )}
        </div>
    )
};

export default PopupPhoneNumbers
